<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{ $t("modal.settings.import_database.title") }}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>

      <div class="alert-info">
        {{ $t("modal.settings.import_database.description") }}
      </div> 

      <label for="images" class="drop-container" v-if="!file">
        {{ $t("modal.settings.import_database.drop") }}
        <input type="file" id="images" accept=".sqlite" @change="selectFile">
      </label>

      <div class="drop-container selected" v-else>
        <div>
          <i class="material-icons">description</i>
          <span class="fileName">{{ file.name }}</span>
        </div>
        
        <i class="material-icons remove" @click="file = null">cancel</i>
      </div>

      <button type="button" :class="{'disabled': !file}" :disabled="!file" @click.stop.prevent="saveAndClose">
        {{ $t("modal.apply") }}
      </button>
      <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
        {{ $t("modal.cancel") }}
      </button>

      <div class="alert-info gray" v-if="process">
        {{ $t("modal.settings.import_database.process") }}
      </div> 
    </form>
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const file = ref();
    const process = ref(false);
    
    onMounted(() => {});

    function selectFile(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (!files[0].name.endsWith('.sqlite')) return;
      if (files[0].size >= 30000000) return;
      file.value = files[0];
    }

    async function closeModal() {
      await store.dispatch("modal_setActive");
    }

    async function saveAndClose() {
      process.value = true;
      const formData = new FormData();
      formData.append('db', file.value);

      store.dispatch('loading_setActive', true);

      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error(window.vueApp.$t("modal.settings.import_database.timeout")));
        }, 900000);
      });

      try {
        await Promise.race([
          store.dispatch('importer_importAdmicomDB', formData),
          timeoutPromise
        ]);
        store.dispatch('loading_setActive', false);
        this.closeModal();
      } catch (error) {
        store.dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.message}`, title: window.vueApp.$t('modal.settings.import_database.title'), error: true});
        process.value = false;
        store.dispatch('loading_setActive', false);
      }
    }

    return {
      file,
      selectFile,
      saveAndClose,
      closeModal,
      process
    };
  },
};
</script>
<style lang="scss">
  .drop-container {
    position: relative;
    display: flex;
    gap: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-radius: 12px;
    border: 2px dashed #555;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;

    input {
      display: none;
    }

    &.selected {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border: 2px solid;

      div {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: lighter;
        font-size: 14px;

        i {
          font-size: 20px;
          color: #555;
        }
      }

      .remove {
        color: tomato;
      }
    }
  }

  .alert-info {
    display: inline-block;
    background: #3f51b5;
    padding: 16px;
    border-radius: 4px;
    margin: 16px 0;

    &.gray {
      background: #555;
      float: right;
    }
  }
</style>
